import { Link } from "react-router-dom";
import { Store } from "lucide-react";
import { fcfa, imgUrl } from "@/lib/api";
import { DemoBadge, PremiumBadge } from "@/components/Badges";

export const ProductCard = ({ p }) => {
  const discount = p.old_price ? Math.round((1 - p.price / p.old_price) * 100) : 0;
  return (
    <Link
      to={`/produit/${p.id}`}
      data-testid={`product-card-${p.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-transform duration-200 hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-square overflow-hidden bg-orange-50">
        {p.images?.[0] && (
          <img src={imgUrl(p.images[0])} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        )}
        <div className="absolute left-2 top-2 flex flex-wrap gap-1">
          {p.demo && <DemoBadge />}
          {p.shop?.premium && <PremiumBadge />}
        </div>
        {discount > 0 && (
          <span className="absolute right-2 top-2 rounded-md bg-green-700 px-1.5 py-0.5 text-xs font-bold text-white">-{discount}%</span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-gray-900">{p.title}</h3>
        <div className="mt-auto flex items-baseline gap-2 pt-1">
          <span className="tnum font-display text-lg font-extrabold text-orange-600">{fcfa(p.price, p.currency)}</span>
          {p.old_price && <span className="tnum text-xs text-gray-400 line-through">{fcfa(p.old_price, p.currency)}</span>}
        </div>
        {p.shop && (
          <span className="flex items-center gap-1 truncate text-xs text-gray-500">
            <Store className="h-3 w-3 shrink-0" /> {p.shop.name}
          </span>
        )}
      </div>
    </Link>
  );
};

export const ProductGrid = ({ items, testid = "product-grid" }) => (
  <div data-testid={testid} className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-5">
    {items.map((p) => <ProductCard key={p.id} p={p} />)}
  </div>
);
